export class LoadCicdRepositoriesGithub {
    static type = '[CICD][Github] LoadCicdRepositoriesGithub'
    constructor() { }
}

export class LoadDataTableCicdRepositoriesGithub {
    static type = '[CICD][Github] LoadDataTableCicdRepositoriesGithub'
    constructor() { }
}

export class UpdateCountersCicdRepositoriesGithub {
    static type = '[CICD][Github] UpdateCountersCicdRepositoriesGithub'
    constructor() { }
}

export class ClearCicdRepositoryGithub {
    static type = '[CICD][Github] ClearCicdRepositoryGithub'
    constructor() { }
}

export class SetCicdRepositoryGithub {
    static type = '[CICD][Github] SetCicdRepositoryGithub'
    constructor(public cicd_repository_id: any) { }
}

export class LoadCicdRepositoriesGithubCharts {
    static type = '[CICD][Github] LoadCicdRepositoriesGithubCharts'
    constructor() { }
}

export class LoadCicdRepositoriesGithubChartsFilteredData {
    static type = '[CICD][Github] LoadCicdRepositoriesGithubChartsFilteredData'
    constructor() { }
}
